// Standard page body inside the app shell: phone-friendly padding, and a centred,
// width-capped column on desktop so forms and lists don't stretch edge to edge.
// `wide` is for tables/grids that benefit from the full desktop width.

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function PageContainer({
  children,
  wide = false,
  className,
}: {
  children: ReactNode;
  wide?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        // Phone-first single column; on wider screens the page uses the full width (pages lay
        // their lists out as multi-column grids there).
        "flex w-full flex-col gap-4 px-4 pt-4 pb-8 md:px-6",
        wide && "max-w-none",
        className,
      )}
    >
      {children}
    </div>
  );
}
